import React, {useState} from "react";
import ProductBacklogTask from "./ProductBacklogTask";
import SprintBacklogTask from "./SprintBacklogTask";
import EditSprintTask from "./EditSprintTask";
import SprintTaskDetails from "./SprintTaskDetail";
import AccumulationChart from "./AccumulationChart";
import TaskDetails from "../productBacklog/TaskDetails";

function SprintBacklogList({
  sprintID,
  pBTasks,
  sprintTasks,
  sprintStatus,
  colourBlindMode,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    taskID: "1",
    taskName: "",
    taskType: "",
    taskStoryPoint: 1,
    taskTag: [],
    taskPriority: "",
    taskDescription: "",
    taskStatus: "",
    taskStage: "",
    taskAssignee: "",
    taskInSprint: false,
  });

  // open model for EditSprintTask
  const openEditSprintTask = (item) => {
    setSelectedItem(item);
    setIsModalOpen(1);
  };

  // open model for task detail
  const openSprintTaskDetails = (item) => {
    setSelectedItem(item);
    setIsModalOpen(2);
  };

  // open model for accumulation chart
  const openAccumulationChart = (item) => {
    setSelectedItem(item);
    setIsModalOpen(3);
  };

  const openTaskDetails = (item) => {
    setSelectedItem(item);
    setIsModalOpen(4);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(0);
  };

  const getAccumData = (rawData) => {
    let x = [...rawData];
    for (let i = 0; i < x.length; i++) {
      if (i === 0) {
        x[i] = x[i].hour;
      } else {
        x[i] = x[i - 1] + x[i].hour;
      }
    }
    return x;
  };

  return (
    <div className="relative ml-[400px] my-[2%]">
      <div className="flex items-center justify-between space-x-[3vw]">
        {/* Product Backlog Task */}
        {sprintStatus === "NotStarted" && (
          <div className="bg-[#3D3E44] w-1/4 h-[75vh] rounded-[50px] pt-[20px]">
            <span className="text-white font-sans text-3xl ml-[30px]">
              Product Backlog
            </span>
            <div className="overflow-y-scroll h-[89%] w-[90%] mt-[10px] ml-[30px]">
              {pBTasks.map((task, index) => (
                <ProductBacklogTask
                  task={task}
                  sprintID={sprintID}
                  openEditSprintTask={openEditSprintTask}
                  openTaskDetails={openTaskDetails}
                  colourBlindMode={colourBlindMode}
                />
              ))}
            </div>
          </div>
        )}

        {/* Not Started */}
        <div className="bg-[#606060] w-1/4 h-[75vh] rounded-[50px] pt-[20px] ">
          <span className="text-white font-sans text-3xl ml-[30px]">
            Not Started
          </span>
          <div className="overflow-y-scroll h-[89%] w-[90%] mt-[10px] ml-[30px]">
            {sprintTasks
              .filter(
                (task) =>
                  task.taskStatus === "NotStarted" && task.sprintID === sprintID
              )
              .map((task, index) => (
                <SprintBacklogTask
                  key={task.id}
                  task={task}
                  openEditSprintTask={openEditSprintTask}
                  openSprintTaskDetails={openSprintTaskDetails}
                  colourBlindMode={colourBlindMode}
                />
              ))}
          </div>
        </div>

        {/* In progress */}
        <div className="bg-[#7E7E7E] w-1/4 h-[75vh] rounded-[50px] pt-[20px] mr-[100px]">
          <span className="text-white font-sans text-3xl ml-[30px]">
            In Progress
          </span>
          <div className="overflow-y-scroll h-[89%] w-[90%] mt-[10px] ml-[30px]">
            {sprintTasks
              .filter(
                (task) =>
                  task.taskStatus === "InProgress" && task.sprintID === sprintID
              )
              .map((task, index) => (
                <SprintBacklogTask
                  task={task}
                  openEditSprintTask={openEditSprintTask}
                  openSprintTaskDetails={openSprintTaskDetails}
                  colourBlindMode={colourBlindMode}
                />
              ))}
          </div>
        </div>

        {/* Completed*/}
        <div className="bg-[#ADADAE] w-1/4 h-[75vh] rounded-[50px] pt-[20px] mr-[100px]">
          <span className="text-white font-sans text-3xl ml-[30px]">
            Completed
          </span>
          <div className="overflow-y-scroll h-[89%] w-[90%] mt-[10px] ml-[30px]">
            {sprintTasks
              .filter(
                (task) =>
                  task.taskStatus === "Completed" && task.sprintID === sprintID
              )
              .map((task, index) => (
                <SprintBacklogTask
                  key={task.id}
                  task={task}
                  openEditSprintTask={openEditSprintTask}
                  openSprintTaskDetails={openSprintTaskDetails}
                  colourBlindMode={colourBlindMode}
                />
              ))}
          </div>
        </div>
      </div>
      {isModalOpen === 1 && (
        <EditSprintTask
          task={selectedItem}
          closeModal={closeModal}
          colourBlindMode={colourBlindMode}
        />
      )}

      {isModalOpen === 2 && (
        <SprintTaskDetails
          task={selectedItem}
          onClose={closeModal}
          openChart={openAccumulationChart}
          colourBlindMode={colourBlindMode}
        />
      )}

      {isModalOpen === 3 && (
        <AccumulationChart
          task={{
            ...selectedItem,
            accumData: getAccumData(selectedItem.sprintLogTime),
          }}
          openSprintTaskDetails={openSprintTaskDetails}
          closeChart={closeModal}
          colourBlindMode={colourBlindMode}
        />
      )}

      {isModalOpen === 4 && (
        <TaskDetails
          task={selectedItem}
          closeModal={closeModal}
          colourBlindMode={colourBlindMode}
        />
      )}
    </div>
  );
}

export default SprintBacklogList;
